var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DebugTableLayout debug",attrs:{"id":"otherguests"}},_vm._l((_vm.debug),function(index){return _c('section',{key:index},[_c('div',{staticClass:"otherguest table",class:("table" + _vm.debug + "_" + index)})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }